export default __webpack_public_path__ + "6b7ec20a3e24cbc4182cd9738f651962.png";